import { createUseStyles } from 'react-jss'

const useErrorStyles = createUseStyles({
  errorWrapper: {
    display: 'flex',
    width: '100%',
    color: '#ff1c24',
    border: '1px solid #ff1c24',
    borderRadius: '5px',
    margin: '10px 0',
    padding: '15px'
  }
})

export { useErrorStyles }
